export default {

  bind(el, binding) {

    el.__clickOutside__ = function(event) {

      if (!el.contains(event.target)) {
        binding.value(event)
      }

    }

    document.addEventListener("mousedown", el.__clickOutside__)

  },

  unbind(el) {

    document.removeEventListener(
      "mousedown",
      el.__clickOutside__
    )

  }

}